import { render } from "./addAdmin.vue?vue&type=template&id=eec7b4fa&scoped=true"
import script from "./addAdmin.vue?vue&type=script&lang=js"
export * from "./addAdmin.vue?vue&type=script&lang=js"

import "./addAdmin.vue?vue&type=style&index=0&id=eec7b4fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eec7b4fa"]])

export default __exports__